<template>
  <div class="animated fadeInRight ecommerce">
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>满免配送配置</div>
        <div class="ibox-tools" style="top:10px;">
          <el-tag :type="form.enabled ? 'success' : 'info'" size="small">
            {{ form.enabled ? '功能已开启' : '功能未开启' }}
          </el-tag>
        </div>
      </div>
      <div class="">
        <el-alert type="info" :closable="false" style="margin-bottom: 15px;">
          <template slot="title">
            配置对<b>平台全部商家</b>的配送单统一生效：商品实付小计（不含运费）≥ 阈值时，用户运费全免；
            减免的运费由平台与商家按比例分摊，分摊金额随订单落库，可在「配送费结算」页对账。
          </template>
        </el-alert>
        <el-form :model="form" label-width="140px" style="max-width: 560px;">
          <el-form-item label="满免阈值（元）" prop="threshold">
            <el-input v-model="form.threshold" placeholder="留空或 0 = 功能关闭" style="width: 260px"></el-input>
            <div class="form-tip">商品实付小计达到该金额即免配送费；只填数字，如 10</div>
          </el-form-item>
          <el-form-item label="平台分摊比例" prop="platformSharePercent">
            <el-input v-model="form.platformSharePercent" placeholder="0-100 的整数，留空 = 0" style="width: 260px">
              <template slot="append">%</template>
            </el-input>
            <div class="form-tip">占减免运费的百分比；0 = 减免金额全部由商家承担</div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" :loading="saving" @click="saveConfig()">
              <i class="el-icon-check"></i> 保存
            </el-button>
            <el-button type="primary" size="small" plain @click="loadConfig()">
              <i class="el-icon-refresh"></i> 重新加载
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryFreeDeliveryConfig, saveFreeDeliveryConfig } from '@/api/order/adminFreeDeliveryApi'

export default {
  name: 'FreeDeliveryConfigManage',
  data() {
    return {
      saving: false,
      form: {
        threshold: '',
        platformSharePercent: '',
        enabled: false
      }
    }
  },
  created() {
    this.loadConfig()
  },
  methods: {
    loadConfig() {
      queryFreeDeliveryConfig().then(res => {
        if (res.code === 0 && res.data) {
          // 回显落库原值（含 0）：0=关闭语义有文案说明，隐藏值会让运营误以为未保存
          this.form.threshold = res.data.threshold || ''
          this.form.platformSharePercent = res.data.platformSharePercent || ''
          this.form.enabled = res.data.enabled === true
        } else {
          this.$message.error((res && res.msg) || '查询配置失败')
        }
      }).catch(() => {
        this.$message.error('查询配置失败')
      })
    },
    saveConfig() {
      // 前端轻校验（后端有强校验兜底）
      if (this.form.threshold && (!/^\d+(\.\d{1,2})?$/.test(this.form.threshold.trim()))) {
        this.$message.warning('满免阈值须为数字（元），最多两位小数')
        return
      }
      if (this.form.platformSharePercent && !/^\d+$/.test(this.form.platformSharePercent.trim())) {
        this.$message.warning('平台分摊比例须为 0-100 的整数')
        return
      }
      this.saving = true
      saveFreeDeliveryConfig({
        threshold: (this.form.threshold || '').trim(),
        platformSharePercent: (this.form.platformSharePercent || '').trim()
      }).then(res => {
        this.saving = false
        if (res.code === 0) {
          this.$message.success('保存成功，已即时生效')
          this.loadConfig()
        } else {
          this.$message.error((res && res.msg) || '保存失败')
        }
      }).catch(() => {
        this.saving = false
        this.$message.error('保存失败')
      })
    }
  }
}
</script>

<style scoped>
.form-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
  margin-top: 4px;
}
</style>
